import { writeDashboardHomeCache } from "./dashboardHomeCache";
import { apiClient } from "./client";
import type { DashboardHomeResponse, DashboardSummaryResponse } from "./types";

export async function fetchDashboardSummary() {
    const response = await apiClient.get<DashboardSummaryResponse>("/dashboard/summary");

    return response.data;
}

export async function fetchDashboardHome() {
    const response = await apiClient.get<DashboardHomeResponse>("/dashboard/home");

    writeDashboardHomeCache(response.data);

    return response.data;
}
